"use strict";

exports.__esModule = true;
exports.DataItemChartV2Thumbnail = DataItemChartV2Thumbnail;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for DataItemChartV2.
 */
function DataItemChartV2Thumbnail(_ref) {
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    x: x,
    y: y,
    viewBox: "-1.5 -4 25 25",
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#A7B6C2",
    d: "M15 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-7H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 13l-6-5-2 2-4-5-4 8V4h16v11z"
  }));
}